export interface MessageFilterCategoryOption {
  value: string;
  label: string;
}

// Updated filter categories - Jan 2026
export const useMessageOutboxCategories: MessageFilterCategoryOption[] = [
  { value: 'not deleted', label: 'Show All Active' },
  { value: 'all', label: 'Show All' },
  { value: 'deleted', label: 'Show Only Deleted' },
];

export default useMessageOutboxCategories;
